import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {FormGroup, FormControl, InputLabel, FormHelperText, OutlinedInput, Select, MenuItem} from '@material-ui/core';
import {isEmpty} from 'lodash/lang';
import {formShape} from 'rc-form';

const SelectField = ({
  name,
  label,
  rules,
  initialValue,
  helpText,
  options,
  labelKey,
  valueKey,
  form: {getFieldProps, getFieldError},
  disabled,
  hideHelpText,
  renderValue,
}) => {
  let errors = getFieldError(name);
  let hasError = !isEmpty(errors);
  let error;
  if (hasError) {
    error = errors[0];
  }

  const inputProps = getFieldProps(name, {
    validate: [{trigger: 'onChange', rules}],
    initialValue,
  });

  return (
    <FormGroup className="mui-form-group">
      <FormControl error={hasError} className="mui-form-control">
        <InputLabel htmlFor={name}>{label}</InputLabel>
        <Select
          value={inputProps.value || ''}
          onChange={inputProps.onChange}
          inputProps={{
            name,
            id: name,
          }}
          disabled={disabled}
          renderValue={renderValue}
        >
          {options.map((option, idx) => (
            <MenuItem key={idx} value={option[valueKey]}>
              {option[labelKey]}
            </MenuItem>
          ))}
        </Select>
        {!hideHelpText && (
          <React.Fragment>
            {helpText && <FormHelperText error={false}>{helpText}</FormHelperText>}
            <FormHelperText error={hasError}>{error}</FormHelperText>
          </React.Fragment>
        )}
      </FormControl>
    </FormGroup>
  );
};

SelectField.propTypes = {
  form: formShape.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.array.isRequired,
  initialValue: PropTypes.any,
  helpText: PropTypes.string.isRequired,
  labelKey: PropTypes.string.isRequired,
  valueKey: PropTypes.string.isRequired,
  options: PropTypes.array,
  disabled: PropTypes.bool.isRequired,
  hideHelpText: PropTypes.bool.isRequired,
  renderValue: PropTypes.func,
};

SelectField.defaultProps = {
  rules: [],
  helpText: '',
  labelKey: 'label',
  valueKey: 'value',
  disabled: false,
  hideHelpText: false,
  clearable: true,
};

export default SelectField;
